import { useMemo } from 'react';
import { Box, Divider, Grid, Typography } from '@mui/material';
import { formatPlaceholder } from '../../../../lib/utils';
import Label from '../../../../ui/primitives/Label';

const FieldLabel = ({ children }) => (
  <Typography
    variant="overline"
    color="text.secondary"
    display="block"
    gutterBottom
  >
    {children}
  </Typography>
);

const FieldValue = ({ children, title }) => (
  <Typography variant="body2" color="text.primary" title={title} sx={{ wordBreak: 'break-word' }}>
    {children}
  </Typography>
);

const TestCaseDetailsComponent = ({ testCase, projectId, labels = [] }) => {
  const labelNames = useMemo(() => {
    if (!testCase?.labels?.length || !labels.length) return [];
    return labels
      .filter((label) => testCase.labels.includes(label.id))
      .map((label) => label.name);
  }, [testCase?.labels, labels]);

  if (!testCase) {
    return (
      <Box sx={{ textAlign: 'center', py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Test case details not available
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {/* Row 1: Description / Objective / Precondition */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <FieldLabel>Description</FieldLabel>
          <FieldValue title={testCase.summary}>{testCase.summary}</FieldValue>
        </Grid>

        <Grid item xs={12} md={4}>
          <FieldLabel>Objective</FieldLabel>
          <FieldValue>{testCase.objective || formatPlaceholder()}</FieldValue>
        </Grid>

        <Grid item xs={12} md={4}>
          <FieldLabel>Precondition</FieldLabel>
          <FieldValue>{testCase.pre_condition || formatPlaceholder()}</FieldValue>
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      {/* Row 2: Status / Priority / Labels */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <FieldLabel>Status</FieldLabel>
          <Label
            color={testCase.status_details?.color || '#6c757d'}
            name={testCase.status_details?.name || 'Unknown'}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <FieldLabel>Priority</FieldLabel>
          <Label
            color={testCase.priority_details?.color || '#6c757d'}
            name={testCase.priority_details?.name || 'Unknown'}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <FieldLabel>Labels</FieldLabel>
          <Typography variant="body2" color="text.primary">
            {labelNames.length ? labelNames.join(', ') : 'None'}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TestCaseDetailsComponent;